import clsx from "clsx";
import styles from "./index.module.scss";
import { TagType } from "@/constants";

type TagProps = {
  type: TagType;
  className?: string;
}

const Tag = (props: TagProps) => {
  const {
    type,
    className,
  } = props;

  return (
    <span
      className={clsx(
        styles["root"],
        styles[type],
        className,
      )}
    >
      {type === TagType.NEW && "NEW"}
      {type === TagType.HOT && "HOT"}
    </span>
  )
}

export default Tag;